import { IconCalendar16 } from '@warp-ds/icons/react';
import { formatClientDate, formatShortenedClientDate, parseISO } from 'shared/util/datetime-fns';

type SearchDetailsDateProps = {
    fromDate?: string | null;
    toDate?: string | null;
};

export const SearchDetailsDate = ({ fromDate, toDate }: SearchDetailsDateProps) => {
    return (
        <div data-testid="searchDetailsDate" className="text-center md:px-24 px-8 flex gap-8 justify-items-center items-center">
            <IconCalendar16 className="md:inline hidden" />
            {!fromDate || !toDate ? (
                <span className="text-s md:text-16">Når som helst</span>
            ) : (
                <>
                    <span className="md:inline hidden">{`${formatClientDate(parseISO(fromDate))}${toDate ? ` - ${formatClientDate(parseISO(toDate))}` : ''}`}</span>
                    <span className="md:hidden text-s">{`${formatShortenedClientDate(parseISO(fromDate))}${toDate ? ` - ${formatShortenedClientDate(parseISO(toDate))}` : ''}`}</span>
                </>
            )}
        </div>
    );
};
